"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How does FMC approach digital transformation for established firms?",
  answer: "We utilize a proprietary 'Liquid Intelligence' framework that audits your current tech stack and identifies high-impact AI integration points. Our goal is to modernize your operations without disrupting the core values that built your success."
}, {
  question: "What is the typical timeline for a strategic consulting engagement?",
  answer: "Engagements vary based on complexity, but most strategic roadmaps are delivered within 4-8 weeks. This includes deep-dive discovery sessions, market analysis, and a finalized implementation plan for your growth marketing or AI solutions."
}, {
  question: "How do your AI solutions differ from off-the-shelf software?",
  answer: "We don't just sell tools; we build bespoke intelligence ecosystems. Our consultants ensure that AI models are trained on your specific business data and integrated directly into your financial advisory or operational workflows for maximum ROI."
}, {
  question: "Can Future Mind Consulting assist with international market expansion?",
  answer: "Yes. Our financial advisory and growth marketing teams specialize in cross-border scaling. We provide the strategic thinking and regulatory insights necessary to transition your business into new global territories effectively."
}];
export default function FutureReadiness() {
  return <section data-section-id="260666" id="future-readiness" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground font-default mb-4 tracking-tight">
            Future Readiness FAQ
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Insights into our modern consulting methodology and strategic innovation processes.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border bg-card/60 backdrop-blur-xl rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:border-primary/30">
              <AccordionTrigger className="px-6 py-4 text-left text-base md:text-xl font-bold font-default text-foreground hover:no-underline hover:bg-primary/5 transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-5 pt-2 text-muted-foreground font-default text-base leading-relaxed bg-transparent">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}